import React from "react";
import Heading from "../Reuse/Heading";
import IncomeCard from "../Reuse/IncomeCard";
import { BsCurrencyDollar } from "react-icons/bs";
import { BsQuestionDiamondFill } from "react-icons/bs";

function QnAIncome({ props }) {
  return (
    <>
      <div className="row">
        <Heading title={"Q&A"} icon={<BsQuestionDiamondFill size={50} />} />
        <IncomeCard
          title={"Total"}
          amount={props?.qnaTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Daily"}
          amount={props?.qnaDailyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Weekly"}
          amount={props?.qnaWeeklyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Monthly"}
          amount={props?.qnaTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Yearly"}
          amount={props?.qnaMonthlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default QnAIncome;
